import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Yes, correct, referential transparency means an expression always 
            evaluates to the same result in any context.
        </p>
        <p>
            Such a function can be analysed and checked in isolation and 
            will always yield the same result.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>Pure functions need referential transparency where the environment 
        remains exactly the same if you replace a function with its result.</p>
        <p>For a given argument, pure functions will always evaluate to 
        the same result.</p> 
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QRefTrans extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Do pure functions need referential transparency?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QRefTrans;


// WEBPACK FOOTER //
// ./src/components/q_ref_trans.js